import React from 'react'
import { useState } from 'react'
import { Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import VideoDetail from './VideoDetail'
import '../Shared/Css/VideoList.css'



function VideoList() {
  const [data, setData] = useState([{ id: 0, 노래: '박은옥', 제목: '봉숭아' }, { id: 1, 노래: '양현경', 제목: '봉숭아' }, { id: 2, 노래: '채정숙', 제목: '봉숭아' }, { id: 3, 노래: '양하영', 제목: '봉숭아' }, { id: 4, 노래: '송소희', 제목: '봉숭아' }])
  const [videoId, setVideoId] = useState()
  const [videoModal, setVideoModal] = useState(false)

  // console.log(data)
  //히스토리사용
  const history = useHistory();

  const CilckHandle = (e) => {
    // console.log(e.target.id)
    setVideoId(e.target.id)
    setVideoModal(true)
  };

  const playerdata = data.map((row, index) => {
    return (
      <div key={index} className="video-container">
        <div onClick={CilckHandle}>
          <video
            id={index}
            // controls
            preload="auto"
            width="100%"
            height="100%"
          >
            <source src={process.env.PUBLIC_URL + "/videolist/bongsunga_p" + index + ".mp4"} />
          </video>
          <div className="video-info">
            <p>제목:{data[index].제목}</p>
            <span>노래:{data[index].노래}</span>
          </div>
        </div>
      </div>
    );
  })

  return (
    <div className='container-lg'>
      <div style={{ float: 'right', padding: '20px 40px' }}>
        <Button
          id="homemove"
          variant="contained"
          // startIcon={HomeIcon}
          style={{
            background: '#004d40',
            color: 'white',
            height: 34,
            width: 120,
            float: "center",
          }}
          onClick={() => { history.goBack(); }}  //이게 더빠름
        // onClick={() => { window.location.href = "/home/index"; }}
        // onClick={() => { window.location.href = "/MenuLink/MenuLink"; }}
        >
          나가기
        </Button>
      </div>
      <div className='video-bg'></div>
      <div className="videolist-container ">
        {playerdata}
      </div>
      {videoModal === true ? <VideoDetail videoId={videoId} videoModal={videoModal} setVideoModal={setVideoModal} /> : null}
    </div>
  )
}

export default VideoList